import { render } from "./ModalAdicionarAcomodacoes.vue?vue&type=template&id=187fd903&scoped=true"
import script from "./ModalAdicionarAcomodacoes.vue?vue&type=script&lang=js"
export * from "./ModalAdicionarAcomodacoes.vue?vue&type=script&lang=js"

import "./ModalAdicionarAcomodacoes.vue?vue&type=style&index=0&id=187fd903&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-187fd903"]])

export default __exports__